module.exports = __webpack_public_path__ + "cc954e7816ed8d5daa66d37f39ee5cee.MP3";